"use client";

import { Button } from "@/components/ui/button";
import { Download, FileDown } from "lucide-react";
import { useReactToPrint } from "react-to-print";
import { useI18n } from "@/lib/i18n/hook";
import { SimulationResult } from "@/lib/simulation";

interface ExportButtonsProps {
  result: SimulationResult;
  printRef: React.RefObject<HTMLDivElement | null>;
}

export function ExportButtons({ result, printRef }: ExportButtonsProps) {
  const { t } = useI18n();

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "Risk Simulation Report",
  });

  const handleExportCSV = () => {
    // CSVヘッダー
    const headers = [
      "Initial Investment",
      "Monthly Investment",
      "Period (Years)",
      "Return Rate (%)",
      "Volatility (%)",
      "Target Amount",
      "Mean Result",
      "Median Result",
      "Success Rate (%)",
    ];

    // CSVデータ行
    const data = [
      result.params.initialInvestment,
      result.params.investmentAmount,
      result.params.investmentPeriod,
      result.params.returnRate,
      result.params.volatility,
      result.params.targetAmount,
      result.statistics.mean,
      result.statistics.median,
      result.successRate,
    ];

    const csvContent =
      "data:text/csv;charset=utf-8," +
      headers.join(",") +
      "\n" +
      data.join(",");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "risk_simulation_result.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex gap-2">
      <Button variant="outline" size="sm" onClick={handleExportCSV}>
        <FileDown className="h-4 w-4 mr-2" />
        CSV
      </Button>
      <Button variant="outline" size="sm" onClick={() => handlePrint()}>
        <Download className="h-4 w-4 mr-2" />
        PDF
      </Button>
    </div>
  );
}
